// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"VP-z","inlineTitle":"WP-z","sponsoredAdsWrapper":"XP-z","marketplaceRecosWrapper":"YP-z"};